

import { Component, ElementRef, ViewChild, OnInit, Input, OnChanges, SimpleChanges, AfterViewInit, OnDestroy, Output, EventEmitter, Inject } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
 
import { APP_CONFIG, AppConfig } from '../../shared-service/app.config';
import { FileUploadService } from '../file-upload/file-upload.service';
import { BaseService } from '../../shared-service/base.service';
import { AuthOIDCService } from '../../auth/authOIDC.service';

//declare var $ :any;
//const URL = 'https://evening-anchorage-3159.herokuapp.com/api/';
@Component({
  selector: 'file-upload-attachement',
  templateUrl: './file-upload-attachement.component.html',
  styleUrls: ['./file-upload-attachement.component.css']
})

export class fileUploadAttachementComponent implements OnInit, OnChanges {

  @Input() fileUploadParamAttachement: Object | any = {};
  private storageLoginKey: PropertyKey = 'LoginDetails';
  private storageFileUploadAttachementDetailKey: PropertyKey = 'FileUploadAttachementDetail';
  public FileUploadAttachementDetail: Object | any= {};
  public AllowFileTypeAttachement: string = "";
  public AcceptedFileType: string = "";
  public AllowFileSizeAttachement: string = "";
  public FileProgessAttachement: number | any;
  public fileDataAttachement: Object | any= {};
  baseUrl: string;
  fileLabel:string='';


  public selectedFiles:any;

  constructor(
    private fileUploadService: FileUploadService, 
    private http: HttpClient, @Inject(APP_CONFIG) config: AppConfig, 
    public bs: BaseService,
    private authOIDCService: AuthOIDCService
  ) {
    this.baseUrl = config.apiEndpoint;
    this.bs.log('info', "Loaded FileUploadComponent");
  }

  ngOnInit() {
    this.bs.log('info', "ngOnInit FileUploadComponent");
    //let loginParams = this.fileUploadService.getStoreData(this.storageLoginKey);
    this.getControlDetailAttacement();
    this.fileLabel=this.bs.getResource(this.fileUploadParamAttachement['FileLabel']);
  };

  ngOnChanges(changes: SimpleChanges) {
    this.bs.log('info',changes);
  }


  getControlDetailAttacement() {
    this.fileUploadService.getFileControlDetailsServer(this.fileUploadParamAttachement,'****').then((data) => {
      this.FileUploadAttachementDetail = data;
      this.AllowFileTypeAttachement = this.FileUploadAttachementDetail['AllowedDisplayFileTypes'];
      this.AllowFileSizeAttachement = this.FileUploadAttachementDetail['AllowFileSize'];
      this.AcceptedFileType = this.FileUploadAttachementDetail['AcceptedFileTypes'];
      this.FileProgessAttachement = 0;

    }, (data) => {
      this.bs.log('error', 'Error in getting list');
    });
  };


  UploadFileAttachement(event:any, fileObject: any) {
    this.bs.log('info','Entering UploadFile');
    this.bs.log('info',fileObject);
    /*@TODO*/
    let loginParams = this.fileUploadService.getStoreData(this.storageLoginKey);

    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      
      let fileData: Object = {};
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('uploadFile', file, file.name);
      formData.append('CorporateID', loginParams.CorporateId);
      formData.append('Culture', loginParams.Culture);
      formData.append('FileUploadToken', this.FileUploadAttachementDetail['FileUploadToken']);
      let headers = new HttpHeaders()
      headers.append('Authorization', 'Bearer ' + this.authOIDCService.token);
      let options = { headers: headers, reportProgress: true, observe: "events" as 'body' };
      let apiUrl1 = this.baseUrl + "FileUpload/UploadJsonFile";
      this.http.post(apiUrl1, formData, options).subscribe(   
        {
          next:(res: any) => {
          if (res.type === HttpEventType.UploadProgress) {
            const percentDone = Math.round(100 * res.loaded / res.total);
            console.log('Progress ' + percentDone + '%');
            this.FileUploadAttachementDetail['FileProgess'] = percentDone;
          }
          if (res.type === HttpEventType.Response) {
            let data = res['body'];
            fileObject['FileName'] = data['FileName'];
            fileObject['FileType'] = data['FileType'];
            fileObject['FileSize'] = data['FileSize'];
            fileObject['SaveFilePath'] = data['SaveFilePath'];
            fileObject['IsVirusInfectedFile'] = data['IsVirusInfectedFile'];
            fileObject['IsValidFileName'] = data['IsValidFileName'];
            fileObject['IsValidFileType'] = data['IsValidFileType'];
            fileObject['IsValidFileLength'] = data['IsValidFileLength'];
            fileObject['IsFileUploadTokenExpired'] = data['IsFileUploadTokenExpired'];
            fileObject['TempPath'] = data['TempPath'];
            //this.UpdateControlData(fileObject);
          }
          },
        error:(error:any)=>{
          throwError(error).subscribe({
            next:(param:any) => {
              this.UpdateControlDataAttachement(fileObject);
            },
            error:(error2: any) => {
              this.bs.log('error', "Error");
            }
          })
           
        }
        })          
    }
  }

  UpdateControlDataAttachement(fileObject: any) {
    this.FileUploadAttachementDetail['IsVirusInfectedFile'] = fileObject['IsVirusInfectedFile'];
    this.FileUploadAttachementDetail['IsValidFileName'] = fileObject['IsValidFileName'];
    this.FileUploadAttachementDetail['IsValidFileType'] = fileObject['IsValidFileType'];
    this.FileUploadAttachementDetail['IsValidFileLength'] = fileObject['IsValidFileLength'];
    this.FileUploadAttachementDetail['IsFileUploadTokenExpired'] = fileObject['IsFileUploadTokenExpired'];
    if (fileObject['IsFileUploadTokenExpired'] == 'False' && fileObject['IsVirusInfectedFile'] == 'False' && fileObject['IsValidFileName'] == 'True' &&  fileObject['IsValidFileType'] == 'True' && fileObject['IsValidFileLength'] == 'True' ) {    
      this.FileUploadAttachementDetail['FileProgess'] = '100';
    }
    else{
      this.FileUploadAttachementDetail['FileName'] = '';
      this.FileUploadAttachementDetail['FileProgess'] = '0';
    }
  }

  IsFileUploadTokenExpired(){
    if (this.FileUploadAttachementDetail['IsFileUploadTokenExpired'] == 'True') {
      return true;
    }
    else {
      return false;
    }
  }

  IsVirusInfectedFileAttachement(){
    if (this.FileUploadAttachementDetail['IsVirusInfectedFile'] == 'True') {
      return true;
    }
    else {
      return false;
    }
  }
  IsValidFileNameAttachement(){
    if (this.FileUploadAttachementDetail['IsValidFileName'] == 'False') {
      return true;
    }
    else {
      return false;
    }
  }
  IsValidFileTypeAttachement(){
    if (this.FileUploadAttachementDetail['IsValidFileType'] == 'False') {
      return true;
    }
    else {
      return false;
    }
  }
  IsValidFileLengthAttachement(){
      if (this.FileUploadAttachementDetail['IsValidFileLength'] == 'False') {
      return true;
    }
    else {
      return false;
    }
  }
  FileSizeAttachement(){
    if (this.FileUploadAttachementDetail['IsVirusInfectedFile'] == 'False' && this.FileUploadAttachementDetail['IsValidFileName'] == 'True' &&  this.FileUploadAttachementDetail['IsValidFileType'] == 'True' && this.FileUploadAttachementDetail['IsValidFileLength'] == 'True') {    
     return true
    }
    else{
      return false;
    }
  }
 
}

